const userAreaCls = "_275upt2u81";
const wrapperCls = "_275wo1umg0";
const focusOnCls = "_275f13xxbdv";
const contentCls = "_275crkw3ic";
const mobileContentWrapperCls = "_275m1jimq83";
const closeButtonCls = "_275c1013fkl";
const backdropCls = "_275b8x3n9q";

export { backdropCls, closeButtonCls, contentCls, focusOnCls, mobileContentWrapperCls, userAreaCls, wrapperCls };
import "./comp.user-area.style.linaria.module.css";
//# sourceMappingURL=comp.user-area.style.js.map
